import React, { useState, useEffect } from "react";
import { fetchSignedUrlMedical } from "../../utils/fileUtils"; // Adjust path to where your function is exported

const ProfilePicture = ({ profileFileKey }) => {
  const [profileUrl, setProfileUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadProfilePic = async () => {
      if (!profileFileKey) {
        setLoading(false);
        return;
      }

      setLoading(true);
      const url = await fetchSignedUrlMedical(profileFileKey);

      if (isMounted && url) {
        setProfileUrl(url);
      }
      if (isMounted) {
        setLoading(false);
      }
    };

    loadProfilePic();

    return () => {
      isMounted = false;
    };
  }, [profileFileKey]);


  if (loading) return <div>Loading picture...</div>;

  return (
    <div className="profile-pic-container">
      {profileUrl ? (
        <img
          src={profileUrl}
          alt="Profile"
          style={{
            width: "100px",
            height: "100px",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />
      ) : (
        <div className="avatar-placeholder">No Image</div>
      )}
    </div>
  );
};

export default ProfilePicture;